// Pagination.jsx
import React from 'react';
import {Link} from "react-router-dom";

function Pagination({paginationData, basePath, paginator}) {
    const pageNumbers = Array.from({length: paginationData.total_pages}, (_, i) => i + 1);

    return (
        <div>
            <ul className="pagination sl-flex sl-flex-wrap sl-m-0 sl-p-2-6-2-8">
                {pageNumbers.map((pageNumber) => (
                    <li key={pageNumber}
                        className={`page-item sl-p-2 ${paginationData.current_page === pageNumber ? 'active sl-font-bold sl-underline' : ''}`}>
                        <Link to={basePath + `/${pageNumber}/${paginator.per_page}`}
                              className="page-link sl-no-underline">
                            {pageNumber}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Pagination;
